
export const GROUPS = {
  "superAdmin": "01fc992b-011f-416a-904f-d08835ef5b7e",
  "admin": "5a9d98b0-641f-4271-b003-8ea8f336bbc4"
}

export function isSuperAdmin() {
  return true ;
  
  const user = getUserMsal()
  const groupsUser = user.idTokenClaims.groups;

  if(!user.idTokenClaims?.groups || groupsUser.lenght < 1)
    return false

  if (!groupsUser.includes(GROUPS.superAdmin)) 
    return false
  
  return true
}

// Get the user
export function getUserMsal() {
  const auth = JSON.parse(localStorage.getItem("msalLoginData")) || null;
  if (auth) {
    return auth.account;
  } else {
    return null;
  }
}